import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CmsService from "services/CMS/";
import ImageLoad from 'components/ImageLoad';
import CMSFactory from "factories/CMS";
import queryString from 'query-string';
import { useIsMounted } from 'hooks';
import TagManagerService from 'services/TagManager';
import PubSub from 'services/PubSub';
import style from './style.scss'; //NOSONAR

let location = '';

const BannerShelf = (props) => {
    const [bannerShelf, setBannerShelf] = useState({});
    const isMounted = useIsMounted();
    const bannerPosition = props.position;
    const typeBannerGtm = (bannerPosition === 'bottom') ? '-Bottom' : '';
    const origin = (bannerPosition === 'bottom') ? 'banner_bottom' : 'banner';

    useEffect(() => {
        location = props.location;
        getContentBanner();
    }, [])

    const getContentBanner = () => {
        const pathname = location.pathname ? location.pathname.replace('/', '').split('/').filter(Boolean).pop() : '';
        if(!pathname) return false;
        let consults = [];
        let typeBanner= '';
        if (pathname === 'busca') {
            const searchParams = queryString.parse(location.search);
            const collection = searchParams.fq ? searchParams.fq.replace('H:','') : '';
            if(collection){
                consults.push(CmsService.getPLP(collection,'collection'));
                typeBanner = "Collections";
            }
        } else {
            consults.push(CmsService.getPLP(pathname,'category'));
            typeBanner = "Categories";
        }

        consults.push(CmsService.getDateTime());

        Promise.all(consults).then(response => {
            if(!isMounted) return false;
            const dateTime = (response && response[1]) ? response[1].datetime : '';
            const banner = (response && response[0]) ? response[0] : [];
            let serverDate = dateTime ? CMSFactory.milliseconds(dateTime) : '';
            let startDate = (banner.acf && banner.acf[origin].start_date) ? CMSFactory.milliseconds(banner.acf[origin].start_date) : '';
            let endDate = (banner.acf && banner.acf[origin].end_date) ? CMSFactory.milliseconds(banner.acf[origin].end_date) : '';

            let validDates = true;

            if (startDate && startDate >= serverDate) validDates = false;
            if (endDate && serverDate >= endDate) validDates = false;

            if (banner && banner.acf && validDates && banner.acf[origin].active && banner.acf[origin].image_mobile && banner.acf[origin].image_desktop) {
                const shelfBanner = banner.acf[origin];

                let imgBanner = shelfBanner ? shelfBanner : '';

                if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                    banner.id = imgBanner && imgBanner.image_mobile ? imgBanner.image_mobile.split('/').pop() : '';
                } else {
                    banner.id = imgBanner && imgBanner.image_desktop ? imgBanner.image_desktop.split('/').pop() : '';
                }


                banner.acf.tag = {
                    id: banner.id,
                    name: (shelfBanner.title === '') ? banner.id : shelfBanner.title,
                    creative: 'Banner-'+typeBanner+ typeBannerGtm,
                    position: 'slot1'
                };

                setBannerShelf(banner.acf);
                PubSub.dispatch('shortcuts_hidden', !(bannerPosition === 'bottom'));
                TagManagerService.promotionsImpressions([banner.acf.tag]);
            } else {
                PubSub.dispatch('shortcuts_hidden', false);
                setBannerShelf(null);
            }
        }).catch(() => {
            PubSub.dispatch('shortcuts_hidden', false);
        });
    }

    const tagClickBanner = (item) => {
        TagManagerService.promotionsClick(item, item.position, item.creative);
    }

    let bannerImg = (bannerShelf && bannerShelf[origin]) ? bannerShelf[origin] : '';
    let imageAlt = (bannerShelf && bannerShelf[origin] && bannerShelf[origin].title) ? bannerShelf[origin].title : (bannerShelf && bannerShelf[origin] && bannerShelf[origin].image_desktop ? bannerShelf[origin].image_desktop : '');

    const imageResponsive = {
        768: bannerImg ? bannerImg.image_mobile : '',
        1440: bannerImg ? bannerImg.image_desktop : ''
    };

    return ((bannerImg) && <div className={"promotion-banner-category" + ((bannerPosition === 'bottom') ? ' banner-bottom' : '')} onClick={() => tagClickBanner(bannerShelf.tag)}>
        <a href={bannerImg.url} style={{ width: '100%' }} target={bannerImg.target}>
            <ImageLoad  srcSet={imageResponsive} src={bannerImg && bannerImg.image_desktop ? bannerImg.image_desktop : ''} alt={imageAlt} />
        </a>
    </div>)
}

BannerShelf.propTypes = {
    location: PropTypes.object
}

export default BannerShelf;
